import { models } from "types/api/viewModels.ts";
import {
	CartItemDescription,
	CartItemSku,
	CartItemWrapper,
	LineItemNumber,
	Thumbnail
} from "features/MarketingMaterials/pages/Checkout/components/CartItem/CartItem.styles.ts";
import { formatPriceWithPrefix } from "utils/string.ts";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { QuantityField } from "features/MarketingMaterials/pages/Checkout/components/CartItem/QuantityField.tsx";
import useMarketingMaterialsCart from "features/MarketingMaterials/hooks/useMarketingMaterialsCart.ts";
import { useNavigate } from "react-router";
import { getMerchandisePrimaryImageUrl } from "features/MarketingMaterials/utils/getMerchandiseImageUrls.ts";

interface CartItemProps {
	item: models["ShoppingCartItem"];
	isEdit: boolean;
	lineNumber: number;
}
export const CartItem = ({ item, isEdit, lineNumber }: CartItemProps) => {
	const navigate = useNavigate();
	const primaryImageUrl = getMerchandisePrimaryImageUrl(item.images);

	const { addCartItem, removeItemFromCart } = useMarketingMaterialsCart();

	const handleOnQuantityChanged = async (quantity: number, isOverride: boolean = false) => {
		await addCartItem(item, quantity, isOverride);
	};

	const handleRemoveItem = async () => {
		await removeItemFromCart(item);
	};

	return (
		<CartItemWrapper isEdit={isEdit}>
			{!isEdit && <LineItemNumber>{lineNumber}</LineItemNumber>}
			<div>
				<CartItemSku
					onClick={() => navigate(`/marketing-materials/items/${item?.id}`)}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							navigate(`/marketing-materials/items/${item?.id}`);
						}
					}}
					role="button"
					tabIndex={0}
					data-testid="cart-item-row-link"
				>
					{item?.name}
				</CartItemSku>
				<CartItemDescription>{item.sku}</CartItemDescription>
			</div>
			<div>
				<Thumbnail
					src={primaryImageUrl}
					alt={item?.name ?? "Product image unavailable"}
				/>
			</div>
			<div>
				{isEdit ? (
					<QuantityField
						quantity={item.quantityOrdered!}
						onQuantityChanged={handleOnQuantityChanged}
					/>
				) : (
					<>
						<p>Qty</p>
						<div>
							<p>{item.quantityOrdered}</p>
						</div>
					</>
				)}
			</div>
			<div>
				<p>Price</p>
				<p>{formatPriceWithPrefix(item?.listPrice, false, true)}</p>
			</div>
			<div>
				<p>Ext. Price</p>
				<p>{formatPriceWithPrefix((item?.listPrice ?? 0) * (item?.quantityOrdered ?? 0), false, true)}</p>
			</div>
			{isEdit && (
				<Button
					variant="text"
					startIcon={<DeleteIcon />}
					onClick={handleRemoveItem}
				>
					REMOVE
				</Button>
			)}
		</CartItemWrapper>
	);
};
